var map = {
	"./en.json": [
		837,
		3
	],
	"./fr.json": [
		838,
		4
	],
	"./nl.json": [
		839,
		5
	],
	"./texts.example.json": [
		840,
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 455;
module.exports = webpackAsyncContext;